import { FabricChannel } from '@atlaskit/analytics-listeners';

/**
 * Analytics channel for Lumina events.
 *
 * Lumina fires events on the `'fabric-elements'` channel, which is automatically
 * picked up by `FabricAnalyticsListeners` in Jira, Confluence, and other products.
 * Events are routed to the GASv3 analytics pipeline and sent to the `/batch` endpoint.
 *
 * Events are distinguishable by their `componentType` and `interactionType` attributes
 * within the 2 base events: `ui.lumina.interacted` and `operational.lumina.errored`.
 *
 * @internal Used internally and by generated analytics code. Consumers use LUMINA_ANALYTICS_CHANNEL.
 */
export const EVENT_CHANNEL = FabricChannel.elements;
